import * as React from "react"
import { IconProps } from "./utils"

export function ContentfulIcon({
  height = 20,
  width = 20,
}: IconProps): JSX.Element {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.22329 16.7767V16.7767C6.95406 15.5111 6.24071 13.7924 6.24071 12C6.24071 10.2076 6.95406 8.4889 8.22329 7.2233V7.2233C9.25279 6.1938 9.25279 4.52465 8.22329 3.49515C7.19379 2.46565 5.52464 2.46565 4.49514 3.49515C2.26423 5.76494 1.00979 8.81741 1 12C1.03165 15.1782 2.28286 18.2228 4.49514 20.5048C5.16111 21.1708 6.13178 21.4309 7.04151 21.1871C7.95124 20.9434 8.66183 20.2328 8.90559 19.323C9.14935 18.4133 8.88926 17.4426 8.22329 16.7767V16.7767Z"
        fill="#FFD85F"
      />
      <path
        d="M8.2233 7.22329V7.22329C9.4889 5.95406 11.2076 5.24071 13 5.24071C14.7924 5.24071 16.5111 5.95406 17.7767 7.22329V7.22329C18.8062 8.25279 20.4753 8.25279 21.5048 7.22329C22.5343 6.19379 22.5343 4.52464 21.5048 3.49514C19.235 1.26423 16.1826 0.00978859 13 0C9.8218 0.0316483 6.77719 1.28286 4.49515 3.49514C3.46565 4.52464 3.46565 6.19379 4.49515 7.22329C5.52465 8.25279 7.1938 8.25279 8.2233 7.22329V7.22329Z"
        fill="#3BB4E7"
      />
      <path
        d="M17.7767 16.7767V16.7767C16.5111 18.0459 14.7924 18.7593 13 18.7593C11.2076 18.7593 9.4889 18.0459 8.2233 16.7767V16.7767C7.1938 15.7472 5.52465 15.7472 4.49515 16.7767C3.46565 17.8062 3.46565 19.4754 4.49515 20.5049C6.76494 22.7358 9.81741 23.9902 13 24C16.1782 23.9683 19.2228 22.7171 21.5048 20.5049C22.1708 19.8389 22.4309 18.8682 22.1871 17.9585C21.9434 17.0487 21.2328 16.3382 20.323 16.0944C19.4133 15.8506 18.4426 16.1107 17.7767 16.7767V16.7767Z"
        fill="#ED5C68"
      />
      <path
        d="M8.30606 7.25777C9.35215 6.21096 9.35155 4.51432 8.30474 3.46824C7.25792 2.42215 5.56129 2.42274 4.5152 3.46956C3.46911 4.51638 3.46971 6.21301 4.51652 7.2591C5.56334 8.30518 7.25997 8.30459 8.30606 7.25777Z"
        fill="#308BC5"
      />
      <path
        d="M8.29397 20.5256C9.34006 19.4788 9.33947 17.7821 8.29265 16.7361C7.24584 15.69 5.5492 15.6906 4.50312 16.7374C3.45703 17.7842 3.45762 19.4808 4.50444 20.5269C5.55126 21.573 7.24789 21.5724 8.29397 20.5256Z"
        fill="#D5465F"
      />
    </svg>
  )
}
